import {
  core_apimessages_CreditCard as CreditCard,
  core_apimessages_AdyenPaymentResult as AdyenPaymentResult,
} from '../schemas/rql';

export interface BillingMethodResult {
  billingMethodUuid?: string;
  creditCard?: CreditCard;
  adyenPaymentResult?: AdyenPaymentResult;
}

/**
 * A billing method result has been successfully set if the response
 * contains a non-null credit card ID. This indicates the card has successfully been
 * updated to that ID.
 */
export function isBillingMethodResultSuccessful(billingMethodResult?: BillingMethodResult) {
  return billingMethodResult && billingMethodResult.creditCard && !!billingMethodResult.creditCard.id;
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/billing/billing_method_result.ts